import { gql, useMutation } from '@apollo/client'
import { SelectShippingMethodsMutation, SelectShippingMethodsMutationVariables } from 'types/graphql'
import { cartFieldsFragment } from './cartFieldsFragment'

const selectShippingMethodsMutation = gql`
  ${cartFieldsFragment}

  mutation SelectShippingMethods($shippingMethods: [ShippingMethodInput!]!, $cartId: ID!) {
    selectShippingMethodsAndGetPaymentIntentSecret(shippingMethods: $shippingMethods, cartId: $cartId) {
      ...CartFields
    }
  }
`

export const useSelectShippingMethods = () => {
  return useMutation<SelectShippingMethodsMutation, SelectShippingMethodsMutationVariables>(selectShippingMethodsMutation, {
    fetchPolicy: 'no-cache'
  })
}
